import * as React from 'react';

import {ButtonGroup} from 'shells/button-group/button-group';
import {Switch} from 'shells/switch/switch';

import {EditionVersionPicker} from './edition-version-picker';
import {TransferEditionContentButton} from './transfer-edition-content-button';

import styles from './compare-content-bar.module.css';

type Props = {
    isComparingContent: boolean;
    edition: any;
    selectedVersionId: string;
    onEditionPickerChange: (value: any) => void;
    onToggleCompareContent: (isComparingContent: boolean) => void;
};

export function CompareContentBar(props: Props) {
    return (
        <div
            className={
                props.isComparingContent
                    ? styles['compare-content-container--active']
                    : styles['compare-content-container']
            }
        >
            <div className={styles['toggle-container']}>
                <Switch
                    isOn={props.isComparingContent}
                    isRounded={true}
                    onChange={() => props.onToggleCompareContent(props.isComparingContent)}
                />
                <span>Test two versions</span>
            </div>
            {props.isComparingContent ? (
                <ButtonGroup>
                    <EditionVersionPicker
                        edition={props.edition}
                        selectedVersionId={props.selectedVersionId}
                        onChange={props.onEditionPickerChange}
                    />
                    <TransferEditionContentButton edition={props.edition} />
                </ButtonGroup>
            ) : null}
        </div>
    );
}
